/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class Hero {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('Hero', Hero)
